<template>
  <el-dialog v-model="dialogVisible" title="查找车辆" :before-close="handleClose" fullscreen>
    <el-form ref="form" :model="listQuery" label-width="100px">
      <el-row type="flex" style="margin: 20px 0 0 88px">
        <el-col>
          <el-row type="flex">
            <el-form-item label="车牌号">
              <el-input  v-model="queryData.numberPlate" placeholder="车牌号模糊查找" />
            </el-form-item>
             <el-form-item label="姓名或/楼栋">
              <el-input  v-model="queryData.carOwnerName" placeholder="姓名或/楼栋查找" />
            </el-form-item>
            <!-- <el-form-item >
              <el-select
                v-model="queryData.isInOut"
                clearable
                placeholder="入场状态查找"
                style="width: 200px"
              >
                <el-option label="未入场" :value="0" />
                <el-option label="已入场" :value="1" />
              </el-select>
            </el-form-item> -->
            <el-form-item>
              <el-button icon="el-icon-search" type="primary"  @click="fetchData">
                查询
              </el-button>
            </el-form-item>
          </el-row>
          <el-row type="flex" style="width: 700px"> </el-row>
        </el-col>
      </el-row>
    </el-form>

    <el-table :data="list" style="width: 100%" stripe border>
      <el-table-column align="center" label="序号">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="停车场" width="190" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.carParkName || "-" }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="联系方式">
        <template #default="{ row }">
          {{
            row.phone
          }}
        </template>
      </el-table-column>

      <el-table-column align="center" label="车牌号" width="150" show-overflow-tooltip>
        <template #default="{ row }">

          <div>
            <el-tag v-if="row.numberPlate.length <= 7" :style="{
                  background: '#1890ff',
                  color: '#fff',
                  width: '80px',
                  height: '30px',
                  fontWeight: '700',
                  lineHeight: '30px',
                  letterSpacing: '0.75px',
                }">
              <span>{{ row.numberPlate }}</span>
            </el-tag>
            <el-tag v-else :style="{
                  background: '#59d69c',
                  color: '#fffefe',
                  width: '80px',
                  height: '30px',
                  fontWeight: '700',
                  lineHeight: '30px',
                  letterSpacing: '0.66px',
                }">
              <span>{{ row.numberPlate }}</span>
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="姓名或/楼栋">
        <template #default="{ row }">
          {{
            row.carOwnerName 
          }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="车辆类型">
        <template #default="{ row }">
          <div v-if="row.vehicleType == 1">
            <el-tag type="info">
              {{ '普通车' }}
            </el-tag>
          </div>
          <div v-else-if="row.vehicleType == 2">
            <el-tag>
              {{ '子母车' }}
            </el-tag>
          </div>
          <div v-else-if="row.vehicleType == 3">
            <el-tag type="warning">
              {{ 'VIP车' }}
            </el-tag>
          </div>
          <div v-else-if="row.vehicleType == 4">
            <el-tag color="#b194fb" style="color: #fff">
              {{ '特殊车' }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="是否入场">
        <template #default="{ row }">
          <div v-if="row.isInOut == 0">
            <el-tag type="info">
              {{ '未入场' }}
            </el-tag>
          </div>
          <div v-else-if="row.isInOut == 1">
            <el-tag>
              {{ '已入场' }}
            </el-tag>
          </div>
          <div v-else>
            <el-tag type="warning">
              {{ '未知' }}
            </el-tag>
          </div>
        </template>
      </el-table-column>

    </el-table>

    <el-pagination background :current-page="queryData.page" :page-size="queryData.size" :page-sizes="[10, 20, 50, 100]" :layout="layout" @size-change="handleSizeChange" @current-change="handleCurrentChange" :total="total" style="margin-top: 10px" />
  </el-dialog>
</template>
<script>
import { getAllCarTypeList, CommunityCarPackage } from "@/network/api";
import { $timeFormat, timeFn } from "@/utils/index";
import { listQuery } from "./queruData";
import zhCn from "element-plus/lib/locale/lang/zh-cn";
// import dayjs from "dayjs";
import { mapState } from "vuex";

export default {
  data() {
    return {
      list: [],
      dialogVisible: false,
      carTypeOptions: [],
      listLoading: false,
      carStatusOption: ["禁用", "正常", "已过期"],
      listQuery: listQuery,
      layout: "total, sizes, prev, pager, next, jumper",
      carParkReleaseType: [
        { key: 0, name: "未知" },
        { key: 1, name: "自动抬杆" },
        { key: 2, name: "人工抬杆" },
        { key: 3, name: "手机放行" },
      ],
      paymentAgencyShortNameOptions: [
        { shortName: "cash_pay_cny", name: "现金支付" },
        { shortName: "pay_online", name: "电子支付" },
        { shortName: "abnormal_termination_of_order", name: "异常放行" },
      ],
      total: 0,
      locale: zhCn,
      inTimeData: [],
      outTimeData: [],
      // carParkOptions: [],
      queryData: {
        numberPlate: '',
        page: 1,
        size: 10,
        isInOut: '',
        carOwnerName:''
      }
    };
  },
  computed: {
    ...mapState(["carParkList"]),
  },
  created() {
    // this.carParkOptions = this.carParkList;
  },
  methods: {
    handleClose(done) {
      done();
    },
    getCarParkReleaseType(key) {
      return this.carParkReleaseType.filter((i) => i.key == key)[0]?.name;
    },
    timeFormat(time, type) {
      return $timeFormat(time, type);
    },
    showDialog() {
      this.dialogVisible = true;
      this.getAllCarTypeList();
      this.fetchData();
    },
    async getAllCarTypeList() {
      const { data, code } = await getAllCarTypeList();
      if (code == 10002) {
        this.carTypeOptions = data;
      } else {
        this.carTypeOptions = [];
      }
    },
    handleQuery() {
      this.queryData.page = 1;
      this.fetchData();
    },
    handleSizeChange(val) {
      this.queryData.size = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.queryData.page = val;
      this.fetchData();
    },

    getTimeFn(inTime, outTime) {
      return timeFn(inTime, outTime);
    },
    // 解决时间搜索 清除后为null的问题
    timeRepairNull(obj) {
      for (const i in obj) {
        if (i != "limit") {
          if (obj[i].value == null) {
            obj[i].value = "";
          }
        }
      }
      return obj;
    },
    getCarTypeName(carType) {
      var carTypeOptions = this.carTypeOptions;
      if (!carType) return "临时车";
      for (let index = 0; index < carTypeOptions.length; index++) {
        if (carTypeOptions[index].flagKey == carType) {
          return carTypeOptions[index]?.name;
        }
      }
    },
    async fetchData() {
      this.listLoading = true;
      // console.log(this.listQuery);
      // if (this.inTimeData?.length > 0) {
      //   this.listQuery.inTimeGT.value = dayjs(this.inTimeData[0]).valueOf();
      //   this.listQuery.inTimeLT.value = dayjs(this.inTimeData[1]).valueOf();
      // } else {
      //   this.listQuery.inTimeGT.value = null;
      //   this.listQuery.inTimeLT.value = null;
      // }

      // if (this.outTimeData?.length > 0) {
      //   this.listQuery.outTimeGT.value = dayjs(this.outTimeData[0]).valueOf();
      //   this.listQuery.outTimeLT.value = dayjs(this.outTimeData[1]).valueOf();
      // } else {
      //   this.listQuery.outTimeGT.value = null;
      //   this.listQuery.outTimeLT.value = null;
      // }

      const { data, total, code, message } = await CommunityCarPackage({ numberPlate: this.queryData.numberPlate, page: this.queryData.page, size: this.queryData.size ,isInOut: this.queryData.isInOut,carOwnerName: this.queryData.carOwnerName});
      this.listLoading = false;

      if (code != 10002) {
        this.$message.error(message);
        return;
      }
      this.list = data;
      console.log(this.list);
      this.total = total;
    },
  },
};
</script>
